module.exports = __webpack_public_path__ + "img/ersterMaiskolben.5f3d46fa.jpg";